module.exports = __webpack_public_path__ + "static/media/14.de2c973a.gif";